export const icons = {
  alert: 'eva:alert-triangle-outline',
  'alert-empty': 'ion:alert',
  'alert-fill': 'eva:alert-triangle-fill',
  'alert-circle-fill': 'carbon:warning-filled',
  'warning-amber': 'ic:outline-warning-amber',
  'account-balance': 'material-symbols:account-balance-outline',
  'social-group': 'foundation:social-myspace',
  archive: 'ic:baseline-inventory',
  'archive-outline': 'material-symbols:archive-outline',
  'arrow-accordion': 'ep:arrow-down-bold',
  'briefcase-arrow-left-right-outline':
    'mdi:briefcase-arrow-left-right-outline',
  'arrow-accordion-up': 'ep:arrow-up-bold',
  'sort-asc': 'mdi:arrow-up',
  'sort-desc': 'mdi:arrow-down',
  sortable: 'mdi:chevron-up-down',
  'arrow-dropdown-down': 'dashicons:arrow-down',
  'arrow-dropdown-down-outline': 'ic:outline-arrow-drop-down',
  'arrow-left': 'mdi:arrow-left',
  'arrow-left-fill': 'fluent:ios-arrow-24-filled',
  'arrow-right-fill': 'fluent:arrow-right-12-filled',
  'arrow-left-circle': 'mdi:arrow-left-circle-outline',
  'arrow-right': 'mdi:arrow-right',
  'outline-trending-down': 'ic:outline-trending-down',
  'outline-trending-up': 'ic:outline-trending-up',
  'arrow-right-outline': 'ic:outline-arrow-right',
  'arrow-outward-outline': 'ic:outline-arrow-outward',
  'arrow-back-ios': 'ic:outline-arrow-back-ios',
  'refresh-user': 'lineicons:refresh-user-1',
  'restore-outline': 'ic:outline-restore',
  'play-circle-outline': 'material-symbols:play-circle-outline',
  'arrow-tree-down': 'ic:outline-arrow-drop-down',
  'arrow-tree-right': 'ic:outline-arrow-right',
  'bill-line': 'mingcute:bill-line',
  api: 'mynaui:api',
  'module-puzzle': 'streamline:module-puzzle-1-remix',
  'chart-line': 'boxicons:chart-line',
  'trending-flat': 'material-symbols:trending-flat',
  'round-person-search': 'ic:round-person-search',
  'credit-card-bold': 'ph:credit-card-bold',
  'add-circle-outline': 'material-symbols:add-circle-outline',
  'user-star': 'mdi:user-star-outline',
  'arrow-up-right': 'ph:arrow-up-right-bold',
  'arrow-forward': 'arrow-ios-forward-fill',
  'arrow-down-circle': 'eva:arrow-circle-down-fill',
  mosaic: 'material-symbols:auto-awesome-mosaic-outline',
  'arrow-left-outlined': 'material-symbols:arrow-left',
  'arrow-right-outlined': 'material-symbols:arrow-right',
  'outline-auto-awesome': 'ic:outline-auto-awesome',
  'search-user': 'mynaui:search-user',
  'account-details-outline': 'mdi:account-details-outline',
  'arrow-merge': 'tabler:arrow-merge',
  'info-filled': 'material-symbols:info',
  'add-task': 'ic:outline-add-task',
  'alpha-d-circle-outline': 'mdi:alpha-d-circle-outline',
  'tasks-all': 'ix:tasks-all',
  'credit-card-add': 'mdi:credit-card-add',
  'five-circle-outline': 'mdi:number-five-circle-outline',
  recent: 'mdi:recent',
  'module-puzzle-1-remix': 'streamline:module-puzzle-1-remix',
  'check-circle-outline-rounded':
    'material-symbols:check-circle-outline-rounded',
  'badge-outline-rounded': 'material-symbols:badge-outline-rounded',
  table: 'lets-icons:table',
  chart: 'bx:chart',
  'department-line': 'mingcute:department-line',
  ticket: 'lucide:ticket',
  'ticket-2': 'gravity-ui:ticket',
  'coins-bold': 'ph:coins-bold',
  smartphone: 'ic:round-smartphone',
  line: 'pepicons-pop:line-x',
  'outline-find-replace': 'ic:outline-find-replace',
  'mdi:briefcase-arrow-left-right-outline':
    'mdi:briefcase-arrow-left-right-outline',
  'chart-donut': 'mdi:chart-donut',
  'insert-chart-outline': 'material-symbols:insert-chart-outline',
  'outline-color-lens': 'ic:outline-color-lens',
  'arrow-left-down-fill': 'eva:diagonal-arrow-left-down-fill',
  'arrow-right-up-fill': 'eva:diagonal-arrow-right-up-fill',
  'arrow-up-bold-duotone': 'solar:double-alt-arrow-up-bold-duotone',
  'arrow-upward-outline': 'eva:arrow-upward-outline',
  'arrow-downward-outline': 'eva:arrow-downward-outline',
  down: 'flat-color-icons:down',
  up: 'flat-color-icons:up',
  'url-checker': 'arcticons:url-checker',
  'insert-link': 'ic:outline-insert-link',
  'hashtag-solid': 'heroicons:hashtag-solid',
  'numbers-outline': 'ic:outline-numbers',
  'published-with-changes': 'material-symbols:published-with-changes',
  bookmark: 'mdi:bookmark-outline',
  enter: 'uil:enter',
  eraser: 'lucide:eraser',
  building: 'ri:building-line',
  'build-outline': 'ic:outline-build',
  type: 'ic:round-merge-type',
  'ic-type': 'ic:outline-merge',
  'time-duration-15': 'tabler:time-duration-15',
  timezone: 'mdi:timezone-outline',
  'email-tick-outline': 'mdi:email-tick-outline',
  network: 'zondicons:network',
  'analytics-outline': 'material-symbols:analytics-outline',
  'dashboard-outline': 'material-symbols:dashboard-outline',
  'bookmark-fill': 'mdi:bookmark',
  'chart-growth': 'ic:twotone-show-chart',
  'Light-bulb-outline': 'charm:lightbulb',
  description: 'material-symbols:featuresDescription',
  reset: 'material-symbols-light:device-reset',
  bell: 'iconoir:bell',
  processing: 'ion:sync',
  'dropDown-up-fill': 'icon-park-solid:up-one',
  'dropDown-down-fill': 'icon-park-solid:down-one',
  'highlight-outline': 'material-symbols:highlight-outline',
  'design-services-outline': 'material-symbols:design-services-outline',
  'bell-ring-outline': 'mdi:bell-ring-outline',
  'badge-outline': 'material-symbols:badge-outline',
  'linkedIn-outline': 'mingcute:linkedin-line',
  business: 'ic:outline-business',
  'business-center': 'ic:outline-business-center',
  'camera-add': 'solar:camera-add-bold',
  camera: 'ic:outline-camera-enhance',
  'business-list': 'ic:outline-business',
  'campaign-outline': 'material-symbols:campaign-outline',
  'bi-type': 'bi:type',
  cancel: 'ic:outline-cancel',
  check: 'mdi:check',
  'fact-check-outline': 'material-symbols:fact-check-outline',
  'code-outline': 'ic:outline-code',
  single: 'fluent:tap-single-48-regular',
  bulk: 'fluent-mdl2:bulk-upload',
  fingerPrint: 'material-symbols:fingerprint',
  'info-circle-outline': 'ic:outline-info',
  'format-clear': 'mdi:format-clear',
  'clear-formatting': 'tdesign:clear-formatting',
  'check-circle-outline': 'ph:check-circle',
  'check-circle': 'mdi:check-circle',
  'check-mark-fill': 'eva:checkmark-circle-2-fill',
  'check-read-linear': 'solar:check-read-linear',
  map: 'gis:world-map-alt',
  'map-outline': 'tabler:map',
  'chevron-down': 'eva:chevron-down-fill',
  'user-details': 'mdi:user-details',
  'user-details-box': 'bxs:user-detail',
  'chevron-up': 'eva:chevron-up-fill',
  earth: 'mdi:earth',
  'user-time': 'tdesign:user-time',
  'chevron-right': 'eva:chevron-right-fill',
  'chevron-left': 'eva:chevron-left-fill',
  'ios-chevron-down': 'eva:arrow-ios-downward-fill',
  'ios-chevron-up': 'eva:arrow-ios-upward-fill',
  'chevron-left-outline': 'ic:outline-chevron-left',
  'credit-card-outlined': 'ic:outline-credit-card',
  'cable-rounded': 'material-symbols:cable-rounded',
  clock: 'solar:clock-circle-outline',
  'lock-rounded': 'ic:round-lock',
  lock: 'uim:lock',
  'user-safety': 'tdesign:user-safety',
  'lock-outline': 'material-symbols:lock-outline',
  'invoice-schedule': 'mdi:invoice-schedule-outline',
  'schedule-outline': 'material-symbols:schedule-outline',
  'access-time': 'ic:baseline-access-time',
  'table-lock': 'fluent:table-lock-24-regular',
  'table-lock-filled': 'tabler:lock-filled',
  'clock-fill': 'ant-design:clock-circle-filled',
  'clock-line': 'iconamoon:clock',
  clockwise: 'ic:outline-history',
  'sync-lock': 'ic:outline-sync-lock',
  'bx-lock': 'bx:lock',
  unlock: 'mi:unlock',
  collections: 'ic:outline-collections',
  diamond: 'ic:outline-diamond',
  danger: 'solar:danger-linear',
  'danger-fill': 'solar:danger-bold',
  delete: 'mdi:delete-outline',
  'delete-regular': 'fluent:delete-12-regular',
  'delete-outline': 'material-symbols:delete-outline',
  dollar: 'mdi:dollar',
  'dollar-rounded': 'material-symbols:monetization-on-outline-rounded',
  domain: 'mdi:domain',
  'domain-add': 'ic:baseline-domain-add',
  download: 'mdi:download',
  'download-offline': 'ic:outline-download-for-offline',
  'download-vector': 'material-symbols:download',
  export: 'uil:export',
  'pajamas-export': 'pajamas:export',
  expand: 'iconoir:expand',
  import: 'uil:import',
  'engineering-outline': 'material-symbols:engineering-outline',
  'download-cloud': 'ic:outline-cloud-download',
  'download-outline': 'mdi:format-vertical-align-bottom',
  'people-outline': 'mdi:people-outline',
  'people-alt-outline': 'ic:outline-people-alt',
  'people-group': 'mdi:people-group-outline',
  'black-people-group': 'mdi:people-group',
  edit: 'mdi:edit-outline',
  'edit-outline': 'mdi:edit-outline',
  'triple-column-edit': 'fluent-mdl2:triple-column-edit',
  'email-search-outline': 'mdi:email-search-outline',
  'email-check-outline': 'mdi:email-check-outline',
  'email-generator-outline': 'streamline:ai-email-generator-spark',
  'email-outline': 'ic:outline-email',
  'email-unread': 'ic:outline-mark-email-unread',
  'alternate-email': 'ic:outline-alternate-email',
  email: 'mdi:email-outline',
  'email-fill': 'mdi:email',
  facebook: 'ri:facebook-fill',
  'insert-drive-file': 'ic:outline-insert-drive-file',
  'file-download': 'la:file-download-solid',
  'file-download-outline': 'material-symbols:file-download',
  flash: 'eva:flash-fill',
  'file-upload': 'eva:cloud-upload-fill',
  upload: 'bi:upload',
  'calender-view-day': 'ic:twotone-calendar-view-day',
  'calender-outline': 'ic:baseline-date-range',
  'file-csv': 'fa-solid:file-csv',
  title: 'material-symbols-light:title-rounded',
  'title-outlined': 'material-symbols:title',
  'meteor-text': 'meteor-icons:text',
  'file-csv-outline': 'bi:filetype-csv',
  'file-excel': 'mdi:file-excel',
  'file-export': 'fa-solid:file-export',
  'filter-alt-outline': 'material-symbols:filter-alt-outline',
  'filter-rounded': 'ic:outline-filter-tilt-shift',
  'upload-web': 'icon-park-outline:upload-web',
  'change-circle-outline': 'ic:outline-change-circle',
  'change-circle': 'material-symbols-light:change-circle',
  'baseline-autorenew': 'ic:baseline-autorenew',
  'arrows-reload': 'ci:arrows-reload-01',
  groups: 'streamline-ultimate:team-meeting',
  'help-circle': 'ic:baseline-help',
  'help-outline': 'material-symbols:help-outline',
  'help-center-outline': 'material-symbols:help-center-outline',
  hub: 'material-symbols:hub-outline',
  'open-in-new-outline': 'fluent:open-24-filled',
  'open-in-new': 'material-symbols:open-in-new',
  info: 'eva:info-outline',
  'info-fill': 'eva:info-fill',
  'library-books': 'ic:outline-library-books',
  laptop: 'ic:baseline-laptop',
  'label-rounded': 'material-symbols-light:label-important-rounded',
  'label-outline': 'iconoir:label',
  'label-rotate-outline': 'mynaui:label',
  'label-off-outline': 'material-symbols:label-off-outline',
  language: 'material-symbols:translate',
  link: 'mdi:link',
  lightbulb: 'ic:outline-lightbulb',
  linkedin: 'eva:linkedin-fill',
  'linkedin-contain': 'mdi:linkedin',
  loading: 'icon-park-outline:loading-one',
  'loading-twotone-loop': 'line-md:loading-twotone-loop',
  'loading-right-outline': 'cuida:loading-right-outline',
  outbox: 'ic:outline-outbox',
  'box-edit-outline': 'fluent:box-edit-20-regular',
  'how-to-reg': 'ic:outline-how-to-reg',
  'new-folder-outline': 'material-symbols:create-new-folder-outline',
  'folder-share-outline': 'material-symbols:folder-shared-outline',
  payment: 'mdi:payment',
  person: 'ic:baseline-person',
  'person-group': 'mdi:person-group',
  'person-outline': 'material-symbols:person-outline',
  'person-search-outline': 'ic:outline-person-search',
  'person-details-outline': 'mdi:person-details-outline',
  plus: 'mdi:plus',
  'plus-circle': 'mdi:plus-circle-outline',
  pin: 'fluent-mdl2:pinned-solid',
  'pin-filled': 'carbon:pin-filled',
  'pin-outlined': 'ic:outline-push-pin',
  'pin-filled-vertical': 'mdi:pin',
  'rocket-launch': 'material-symbols:rocket-launch-outline',
  reorder: 'mi:reorder',
  finances: 'ic:outline-monetization-on',
  tag: 'solar:tag-horizontal-bold-duotone',
  'number-tag': 'material-symbols:tag',
  tags: 'tabler:tags',
  'tag-black': 'solar:tag-horizontal-bold',
  'park-drag': 'icon-park:drag',
  'drag-vertical-outline': 'teenyicons:drag-vertical-outline',
  privacy: 'flat-color-icons:privacy',
  receipt: 'ic:outline-receipt-long',
  'receipt-outline': 'material-symbols:receipt-outline',
  'rotate-right': 'mdi:rotate-right',
  'view-in-ar': 'ic:outline-view-in-ar',
  'view-week-outline': 'material-symbols:view-week-outline',
  view: 'carbon:view',
  'rotate-360': 'mdi:rotate-360',
  search: 'mdi:search',
  multiselect: 'fluent:multiselect-16-regular',
  'select-all': 'fluent:select-all-on-20-regular',
  attachment: 'clarity:attachment-line',
  'search-fill': 'eva:search-fill',
  'manage-search': 'material-symbols:manage-search',
  'manage-accounts-outline': 'material-symbols:manage-accounts-outline',
  'search-line': 'ri:search-line',
  'search-insights-rounded': 'material-symbols:search-insights-rounded',
  coin: 'ph:coin-duotone',
  'coin-white': 'ph:coin',
  send: 'mdi:send-outline',
  smile: 'mdi:mood',
  target: 'ph:lifebuoy-bold',
  trash: 'ph:trash-bold',
  upgrade: 'mdi:trending-up',
  downgrade: 'mdi:trending-down',
  twitter: 'ri:twitter-x-fill',
  'user-circle': 'mdi:user-circle-outline',
  'user-outline': 'tdesign:user',
  avatar: 'prime:user',
  close: 'mingcute:close-line',
  'close-circle': 'solar:close-circle-bold',
  'close-circle-outline': 'carbon:close-outline',
  copy: 'ic:baseline-content-copy',
  'copy-uil': 'uil:copy',
  'more-vertical': 'mingcute:more-2-fill',
  'more-horizontal': 'mingcute:more-1-fill',
  'more-grid': 'garden:grid-3x3-fill-12',
  'details-line': 'clarity:details-line',
  copyIcon: 'ic:outline-content-copy',
  'copy-all-outline': 'material-symbols:copy-all-outline',
  'copy-24': 'octicon:copy-24',
  'copy-outline': 'material-symbols:content-copy-outline',
  reload: 'mdi:reload',
  excel: 'mdi:file-excel',
  exit: 'ic:outline-exit-to-app',
  file: 'mdi:file',
  'file-outline': 'mdi:file-outline',
  'folder-outline': 'pepicons-pop:folder',
  'folder-management': 'lucide:folder-cog',
  'folder-open-outline': 'ic:outline-folder-open',
  'folder-special': 'material-symbols:folder-special-outline',
  'upload-cloud': 'eva:cloud-upload-fill',
  setting: 'solar:settings-bold-duotone',
  'star-sharper': 'el:star-alt',
  'address-book': 'ph:address-book',
  'medal-star': 'solar:medal-star-linear',
  'supervised-user-circle': 'material-symbols:supervised-user-circle-outline',
  calendar: 'solar:calendar-mark-bold-duotone',
  'calendar-view-month-outline': 'material-symbols:calendar-view-month-outline',
  'today-calendar': 'majesticons:calendar-line',
  eye: 'solar:eye-bold',
  'eye-off': 'ant-design:eye-invisible-outlined',
  'eye-outlined': 'ic:outline-remove-red-eye',
  'eye-lock-outline': 'mdi:eye-lock-outline',
  feather: 'ph:feather',
  'star-outline': 'mdi:star-outline',
  'photo-up': 'tabler:photo-up',
  'photo-outline': 'ic:outline-photo',
  star: 'material-symbols:star',
  'send-to-moblie': 'material-symbols:send-to-mobile-outline',
  phone: 'ic:outline-phone',
  'phone-enabled-outline': 'material-symbols:phone-enabled-outline',
  'link-out': 'material-symbols:link',
  'setting-1': 'tdesign:setting-1',
  'settings-motion-mode':
    'material-symbols:settings-motion-mode-outline-rounded',
  minus: 'mdi:minus',
  'search-1': 'iconamoon:search',
  'people-community': 'fluent:people-community-28-regular',
  'info-1': 'fluent:info-12-filled',
  dot: 'carbon:dot-mark',
  play: 'mdi:play',
  'play-solid': 'icon-park-solid:play',
  'location-searching': 'material-symbols:location-searching',
  'show-chart': 'material-symbols:show-chart',
  'keyboard-double-arrow-right': 'material-symbols:keyboard-double-arrow-right',
  'key-outline': 'material-symbols:key-outline',
  'apartment-rounded': 'material-symbols:apartment-rounded',
  'outline-source': 'ic:outline-source',
  'playlist-add': 'ic:outline-playlist-add-check-circle',
  'play-outline': 'line-md:play',
  'baseline-cloud': 'ic:baseline-cloud',
  'cloud-done-outline': 'material-symbols:cloud-done-outline-rounded',
  'done-all-outline': 'ic:outline-done-all',
  refresh: 'lucide:refresh-ccw',
  'refresh-outline': 'ic:outline-refresh',
  'sync-outline': 'ic:outline-sync',
  autorenew: 'ic:outline-autorenew',
  tick: 'mdi:tick',
  confirm: 'line-md:circle-to-confirm-circle-transition',
  world: 'tabler:world',
  block: 'ic:outline-block',
  history: 'mdi:history',
  columns: 'material-symbols:view-column-outline',
  bill: 'uil:receipt',
  billing: 'ic:outline-receipt-long',
  'bill-list-outline': 'solar:bill-list-outline',
  keyboard: 'material-symbols:keyboard-outline',
  'dollar-outline': 'ic:outline-monetization-on',
  'arrow-right-rounded': 'material-symbols:arrow-forward-rounded',
  list: 'material-symbols:list',
  'list-outline': 'ic:outline-list',
  'list-add': 'ic:round-playlist-add',
  'list-remove': 'gg:play-list-remove',
  'list-remove2': 'ci:list-remove',
  'account-list': 'material-symbols:list',
  'list-filled': 'fluent:list-16-filled',
  'patient-list-outline': 'material-symbols:patient-list-outline',
  reply: 'mdi:reply-outline',
  spoke: 'material-symbols:spoke-outline',
  'date-range': 'material-symbols:date-range-outline',
  'near-me': 'material-symbols:near-me-outline',
  'cell-tower': 'material-symbols:cell-tower',
  'notifications-active': 'material-symbols:notifications-active-outline',
  fingerprint: 'mdi:fingerprint',
  people: 'mdi:people-outline',
  home: 'mdi:home-outline',
  'home-light': 'iconamoon:home-light',
  user: 'lucide:users',
  'user-add': 'heroicons-outline:user-add',
  'team-meeting': 'streamline-ultimate:team-meeting',
  'user-add2': 'tdesign:user-add',
  'user-waves': 'mynaui:user-waves',
  'user-crown': 'iconoir:user-crown',
  save: 'ic:outline-save',
  'read-more': 'ic:sharp-read-more',
  'view-compact': 'mdi:view-compact-outline',
  verified: 'material-symbols:verified-outline',
  'reader-mode': 'material-symbols:chrome-reader-mode-outline',
  'playlist-add-outline': 'material-symbols:playlist-add',
  'vertical-align-bottom': 'ic:baseline-vertical-align-bottom',
  grain: 'material-symbols:grain',
  equalizer: 'material-symbols:graphic-eq',
  grid: 'mdi:grid',
  'grid-add': 'tdesign:grid-add',
  flag: 'material-symbols:flag-outline',
  location: 'humbleicons:location',
  contactless: 'ic:outline-contactless',
  portrait: 'ic:outline-portrait',
  workspace: 'material-symbols:workspace-premium-outline',
  premium: 'fluent:premium-20-regular',
  'work-outline': 'material-symbols:work-outline',
  'work-history-outline': 'ic:outline-work-history',
  'arrow-drop-down': 'ri:arrow-drop-down-fill',
  'arrow-drop-up': 'ri:arrow-drop-up-fill',
  'arrow-drop-right': 'ri:arrow-drop-right-fill',
  'work-alert-outline-rounded': 'material-symbols:work-alert-outline-rounded',
  corporate: 'material-symbols:corporate-fare',
  contacts: 'ic:outline-contacts',
  contact: 'typcn:contacts',
  'accounts-tree': 'material-symbols:account-tree-outline',
  label: 'mdi:label-outline',
  supervisor: 'material-symbols:supervisor-account-outline',
  questionMark: 'ic:outline-question-mark',
  A: 'mdi:alphabet-a',
  instagram: 'ri:instagram-fill',
  factory: 'material-symbols:factory-outline',
  function: 'mdi:function',
  'add-circle-outlined': 'gridicons:add-outline',
  'add-outlined': 'basil:add-outline',
  'forward-fill': 'eva:arrow-ios-forward-fill',
  'back-fill': 'eva:arrow-ios-back-fill',
  'edit-role': 'fluent:contact-card-link-20-regular',
  'edit-2': 'lucide:edit',
  germany: 'openmoji:flag-germany',
  canada: 'openmoji:flag-canada',
  unitedStates: 'openmoji:flag-united-states',
  university: 'nimbus:university',
  'pulse-01': 'hugeicons:pulse-01',
  'person-off-outline': 'material-symbols:person-off-outline',
  'menu-book': 'ic:outline-menu-book',
  'sticky-note': 'ic:outline-sticky-note-2',
  note: 'fluent:note-16-regular',
  'notes-outline': 'ic:outline-notes',
  volunteer: 'ic:outline-volunteer-activism',
  yard: 'ic:outline-yard',
  recommend: 'ic:outline-recommend',
  'gift-card': 'ic:outline-card-giftcard',
  'user-check': 'iconoir:user-badge-check',
  'user-check-outline': 'mdi:user-check-outline',
  'person-delete-outline': 'eva:person-delete-outline',
  'chat-outlined': 'ic:outline-chat-bubble-outline',
  'bar-chart': 'ic:outline-bar-chart',
  money: 'majesticons:money-line',
  'product-release': 'fluent-mdl2:product-release',
  'location-multiple': 'mdi:location-multiple-outline',
  'service-toolbox': 'material-symbols-light:service-toolbox-outline-rounded',
  'user-admin': 'grommet-icons:user-admin',
  'video-call': 'fluent:video-person-call-16-regular',
  'video-person-call': 'fluent:video-person-call-24-regular',
  'video-camera': 'heroicons-outline:video-camera',
  labels: 'tabler:tags',
  'triangle-left-fill': 'gravity-ui:triangle-left-fill',
  sidebar: 'pajamas:sidebar',
  'account-tag': 'mdi:account-tag-outline',
  wireless: 'mdi:wireless',
  prohibited: 'mdi:prohibited',
  remove: 'mdi:remove',
  'phone-video': 'icon-park-outline:phone-video-call',
  chat: 'ph:chats-bold',
  update: 'qlementine-icons:update-16',
  'update-outline': 'ic:outline-update',
  deal: 'mdi:deal-outline',
  'alphabet-D': 'mdi:alphabet-d-circle-outline',
  'alphabet-P': 'mdi:alphabet-p',
  'alphabet-S': 'mdi:alphabet-s',
  'alphabet-s-circle-outline': 'mdi:alphabet-s-circle-outline',
  'alphabet-p-circle-outline': 'mdi:alphabet-p-circle-outline',
  'number-5': 'mdi:number-5-circle-outline',
  'user-group': 'mynaui:users-group',
  newspaper: 'ic:outline-newspaper',
  power: 'ic:outline-power',
  signal: 'ic:outline-signal-wifi-0-bar',
  work: 'material-symbols:work-outline',
  traffic: 'ic:outline-traffic',
  'published-with': 'material-symbols:published-with-changes',
  'nearby-error': 'material-symbols:nearby-error',
  'product-and-services': 'fluent-mdl2:product-variant',
  'user-box': 'lets-icons:user-box',
  package: 'fluent:box-edit-20-regular',
  'file-user-outline': 'basil:file-user-outline',
  'user-identifier-card': 'streamline:user-identifier-card',
  'email-refresh-outline': 'mdi:email-refresh-outline',
  signals: 'gravity-ui:signal',
  'stop-sign': 'jam:stop-sign',
  'filter-star': 'tabler:filter-star',
  footstep: 'ion:footsteps-sharp',
  'merge-type': 'ic:sharp-merge',
  shield: 'dashicons:shield',
  'content-communication': 'icon-park-outline:communication',
  feature: 'material-symbols:featured-play-list-outline',
  customization: 'material-symbols:inbox-customize-rounded',
  'circle-four': 'icon-park-outline:circle-four',
  'invoice-text': 'mdi:invoice-text-fast-outline',
  'contact-card': 'fluent-mdl2:contact-card-settings',
  'account-shield': 'mdi:shield-account-variant-outline',
  data: 'majesticons:data-line',
  'database-search-outline': 'material-symbols:database-search-outline',
  'check-fill': 'lets-icons:check-fill',
  'database-outline': 'mdi:database-outline',
  'view-in-ar-outline': 'material-symbols:view-in-ar-outline',
  'paste-outline': 'ic:outline-content-paste',
  'pencil-ruler': 'mingcute:pencil-ruler-line',
  'play-video': 'carbon:play-filled',
  calculator: 'ant-design:calculator-outlined',
  logout: 'humbleicons:logout',
  develop: 'material-symbols:developer-mode-outline',
  tie: 'mdi:account-tie-outline',
  industry: 'la:industry',
  'api-outline': 'ic:outline-api',
  'database-search': 'material-symbols:database-search-outline',
  error: 'material-symbols:error-outline',
  problem: 'ic:outline-report-problem',
  'speed-outline': 'ic:outline-speed',
  'dynamic-form-outline': 'material-symbols:dynamic-form-outline',
  'job-change': 'mdi:briefcase-arrow-left-right-outline',
  'api-text': 'mdi:api',
  'user-setting': 'mdi:account-cog-outline',
  'filter-list': 'ic:outline-filter-list',
  password: 'ic:outline-password',
  '1k': 'material-symbols:1k-outline',
  'outline-upgrade': 'ic:outline-upgrade',
  'full-screen-exit': 'ic:sharp-fullscreen-exit',
  'people-group-outline': 'mdi:people-group-outline',
  'left-panel-close': 'mynaui:panel-left-close',
  'left-panle-open': 'mynaui:panel-left-open',
  'add-image': 'material-symbols:add-photo-alternate-outline',
  'groups-outlined': 'material-symbols:groups-outline',
  'calendar-today-outline': 'material-symbols:calendar-today-outline',
  'lan-outline': 'material-symbols:lan-outline',
  'share-location': 'material-symbols:share-location',
  'hourglass-empty': 'mdi:hourglass-empty',
  'gps-fixed': 'ic:baseline-gps-fixed',
  'text-fields': 'material-symbols:text-fields',
  subscriptions: 'material-symbols:subscriptions-outline',
  'lock-filled': 'tabler:lock-filled',
  'group-search': 'material-symbols:group-search-outline',
  skills: 'icon-park-outline:increase',
  'add-photo': 'ic:outline-add-a-photo',
  'external-link': 'mdi:external-link',
  'info-filled-bitcoin': 'bitcoin-icons:info-filled',
  'keyboard-arrow-down': 'ic:outline-keyboard-arrow-down',
  'keyboard-arrow-up': 'ic:baseline-keyboard-arrow-up',
  'pajamas-labels': 'pajamas:labels',
  'circle-outlined': 'material-symbols-light:circle-outline',
  animation: 'material-symbols:animation',
  'outline-group': 'ic:outline-group',
  'ic-label': 'ic:outline-label',
  'ic-new-label': 'ic:outline-new-label',
  'ic-outline-label-off': 'ic:outline-label-off',
  'outline-industry': 'ic:outline-factory',
  '10-plus': 'uil:10-plus',
  'outline-key': 'ic:outline-key',
  'ic-dynamic-form-outline': 'ic:outline-dynamic-form',
  'ssid-chart': 'ic:outline-ssid-chart',
  'office-building-location': 'mdi:office-building-location-outline',
  undo: 'ic:outline-undo',
  'art-track': 'ic:outline-art-track',
  'grid-3x3-outline': 'ic:outline-grid-3x3',
  'watch-later-outline': 'ic:outline-watch-later',
  'share-outline': 'material-symbols:share-outline',
};
